export default function removeChars(str: string, chars: string): string {
    return str.split("").filter(c => !chars.includes(c)).join("");
}